import { HomeStepType } from 'scenes/home/types';

export const homePageTitles: {
  [key in HomeStepType]: string;
} = {
  [HomeStepType.CoverTypeSelection]: 'Cover type',
  [HomeStepType.PolicyStartDate]: 'Policy start date',
  [HomeStepType.RiskAddress]: 'Home address',
  [HomeStepType.Ownership]: 'Ownership',
  [HomeStepType.PropertyUsedForBusiness]: 'Used for business',
  [HomeStepType.PropertyBusinessType]: 'Business type',
  [HomeStepType.PropertyPurpose]: 'Home purpose',
  [HomeStepType.KickOutChoice]: 'Purpose confirmation',
  [HomeStepType.PersonalOrBusinessPolicy]: 'Issued to person or business',
  [HomeStepType.ContactDateOfBirth]: 'Date of birth',
  [HomeStepType.RecentInsurer]: 'Recent insurer',
  [HomeStepType.YearsInsured]: 'Years insured',
  [HomeStepType.ClaimsMade]: 'Claims made',
  [HomeStepType.BuildingType]: 'Building type',
  [HomeStepType.BreakInAndAdditionalSecurity]: 'Additional security',
  [HomeStepType.NumberOfBedrooms]: 'Number of bedrooms',
  [HomeStepType.PropertyBuiltYear]: 'Year built',
  [HomeStepType.RoofMaterial]: 'Roof material',
  [HomeStepType.WallMaterial]: 'Wall material',
  [HomeStepType.SecurityFeatures]: 'Security features',
  [HomeStepType.SumInsuredChoice]: 'Total cost to rebuild',
  [HomeStepType.SumInsuredBuildingValue]: 'Property sum insured',
  [HomeStepType.SumInsuredContentsValue]: 'Contents sum insured',
  [HomeStepType.FlybuysNumber]: 'Flybuys number',
  [HomeStepType.PromoCode]: 'Promo code',
  [HomeStepType.QuotePrice]: 'Your quote price',
  [HomeStepType.BuildingExcess]: 'Building excess',
  [HomeStepType.ContentsExcess]: 'Contents excess',
  [HomeStepType.OptionalExtras]: 'Optional extras',
  [HomeStepType.SpecifiedContentsAnswer]: 'Specified items higher than limits',
  [HomeStepType.SpecifiedContentList]: 'List of specified contents',
  [HomeStepType.AddSpecifiedContent]: 'Add specified contents',
  [HomeStepType.UnspecifiedPortableContents]: 'Unspecified contents',
  [HomeStepType.PropertyCondition]: 'Home condition',
  [HomeStepType.HeritageListed]: 'Heritage listed',
  [HomeStepType.RewiredOrReplumbed]: 'Re-wired or re-plumbed',
  [HomeStepType.PropertyUnoccupied]: 'Home unoccupied',
  [HomeStepType.PropertyRenovation]: 'Home renovation',
  [HomeStepType.Over5Acres]: 'Large block',
  [HomeStepType.PropertyOccupancy]: 'Home occupancy',
  [HomeStepType.OccupantsHistory]: 'Occupants history details',
  [HomeStepType.CashKeptAtHome]: 'Cash at home for business',
  [HomeStepType.StockKeptAtHome]: 'Business stock at home',
  [HomeStepType.HazardGoodsKeptAtHome]: 'Hazardous goods at home',
  [HomeStepType.NumberOfVisits]: 'Number of visits for business',
  [HomeStepType.BusinessRegisteredForGst]: 'Business registered for GST',
  [HomeStepType.MortgageProvider]: 'Mortgage provider',
  [HomeStepType.BusinessNameAndAbn]: 'Business details',
  [HomeStepType.BusinessContact]: 'Business contact',
  [HomeStepType.PersonalPolicyContact]: 'Main policy holder',
  [HomeStepType.ContactEmailAddress]: 'Policy holder email address',
  [HomeStepType.ContactPhoneNumber]: 'Policy holder phone number',
  [HomeStepType.AddAdditionalPolicyHolder]: 'Add additional policy holder',
  [HomeStepType.AdditionalPolicyHolder]: 'Additional policy holder',
  [HomeStepType.AdditionalPolicyHolderList]: 'Additional policy holder list',
  [HomeStepType.PostalAddress]: 'Postal address',
  [HomeStepType.DifferentPostalAddress]: 'Postal address',
  [HomeStepType.DifferentPostalAddressManual]:
    'Different postal address manual',
  [HomeStepType.LockedBagAddress]: 'Locked bag address',
  [HomeStepType.MarketingConsent]: 'Marketing consent',
  [HomeStepType.TermsAndConditions]: 'Terms and conditions',
  [HomeStepType.Summary]: 'Review summary',
  [HomeStepType.PaymentFrequency]: 'Payment frequency',
  [HomeStepType.PaymentDate]: 'Payment date',
  [HomeStepType.PaymentMethod]: 'Payment method',
  [HomeStepType.DirectDebitPayment]: 'Direct debit payment',
  [HomeStepType.CreditCardPayment]: 'Credit card payment',
  [HomeStepType.PaymentConfirmation]: 'Payment confirmation',
  [HomeStepType.ReviewPolicyStartDate]: 'Review policy start date',
};

export default homePageTitles;
